import { render, staticRenderFns } from "./OwnerEditPage.vue?vue&type=template&id=edef61ce&"
import script from "./OwnerEditPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports